<template>
  <div id="stripe-mobile-redirect">
    <b-button @click="redirect">Open SH App</b-button>
  </div>
</template>

<script>
export default {
  name: "StripeMobileRedirect",
  mounted() {
    this.redirect();
  },
  methods: {
    redirect() {
      if (this.$route.name === "mobileTransactionCancelled") {
        window.location.href = "spectrum://transaction-cancelled";
      } else {
        window.location.href =
          "spectrum://transaction-success?session_id=" +
          this.$route.query.session_id;
      }
    }
  }
};
</script>

<style lang="less">
#stripe-mobile-redirect {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
